// Entegrasyonu Düzenle penceresi (pazaryeri / yemek / kargo) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.editIntegration';

export const editIntegrationModalGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Entegrasyon nasıl düzenlenir?'),
  intro: t(`${G}.intro`, 'Bu pencerede bağlı bir platformun durumunu görür, anahtarlarını, şubesini ve gönderici bilgilerini günceller, bağlantıyı test edersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Entegrasyonu Düzenle'),
    body: t(`${G}.regions.body`, 'Mevcut Durum, ayarlar ve API Bilgileri'),
    footer: t(`${G}.regions.footer`, 'İptal / Güncelle'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Mevcut durumu okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki Mevcut Durum kutusu bağlantının son test sonucunu (Bağlı / Bağlantı Hatası), Hata Sayısını, Son Senkronizasyon zamanını ve varsa bağlı Şubeyi gösterir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Getir Food kayıtlarında ayrıca "Getir POS Entegrasyon Durumu" kutusu çıkar: AÇIK / KAPALI durumunu gösterir; "POS Entegrasyonunu Aç / Kapat" ile değiştirir, "Yenile" ile yeniden sorgularsınız.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Genel ayarlar ve şube'),
      text: t(`${G}.s2.text`, '"Entegrasyonu Etkinleştir" ile kaydı açar veya pasife alırsınız. Yemek platformlarında Şube ve Mağaza / Marka Adı (zorunlu, en fazla 150 karakter) da burada değiştirilir. Aynı şubede aynı adla başka bir mağaza varsa kayıt reddedilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Markaya özel fiş başlığı (yemek)'),
      text: t(`${G}.s3.text`, '"Fiş Başlığı (Bu Markaya Özel)" başlığına tıklayınca bölüm açılır. Buradaki bilgiler yalnız bu markanın siparişlerinde basılan fişin başlığında ve alt bilgisinde kullanılır; boş bıraktığınız alanlarda ekran ayarındaki değerler geçerli olur. "Varsayılana dön" markaya özel başlığı kaldırır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. API ve gönderici bilgileri'),
      text: t(`${G}.s4.text`, 'Alanlar ekleme penceresindekiyle aynıdır: pazaryerinde API Key / API Secret (Trendyol, Hepsiburada, Amazon ve Pazarama\'da Seller ID / MerchantId / Satıcı ID de zorunlu), yemek platformunda platformun kimlik bilgileri, HepsiJet ve DHL (MNG)\'de hesap bilgileri ile Gönderici / Firma Bilgileri. Mevcut gönderici bilgileri pencere açılınca kendiliğinden doldurulur.'),
      tips: [
        t(`${G}.s4.tip1`, 'MNG\'de kayıtlı bir güvenlik dizgisi varsa alanı boş bırakırsanız mevcut değer korunur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Bağlantıyı test edin'),
      text: t(`${G}.s5.text`, '"Bağlantıyı Test Et" (Trendyol\'da "Trendyol API Testi") düğmesi önce zorunlu alanları kontrol eder. Trendyol, N11, Hepsiburada ve Pazarama\'da platforma gerçek bir bağlantı denenir; sonuç Mevcut Durum rozetine ve listeye yazılır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Gerçek test kaydedilmiş bilgilerle yapılır. Anahtarları değiştirdiyseniz önce "Güncelle" ile kaydedin, sonra pencereyi yeniden açıp test edin.'),
        t(`${G}.s5.tip2`, 'Diğer platformlarda (Amazon, PttAVM, yemek ve kargo) düğme yalnız alanların dolu olduğunu kontrol eder ve kaydı "Bağlı" işaretler; gerçek bağlantı denenmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Güncelleyin'),
      text: t(`${G}.s6.text`, '"Güncelle" değişiklikleri kaydeder; başarı mesajından kısa süre sonra pencere kapanır ve liste yenilenir. Kayıt reddedilirse nedeni (ör. mağaza kimliği başka bir kayıtta kullanılıyor) kırmızı kutuda yazar.'),
    },
  ],
});
